export enum AirConditioningType {
  AUTONOMO = 'AUTONOMO',
  CENTRALIZZATO = 'CENTRALIZZATO',
  PREDISPOSIZIONE = 'PREDISPOSIZIONE',
  ASSENTE = 'ASSENTE',
}
